const XpBar_SVG = ({...props}) => {
	return (
			<svg width="342"
			     height="37"
			     viewBox="0 0 342 37"
			     fill="none"
			     xmlns="http://www.w3.org/2000/svg"
			     {...props}
			>
				<g clipPath="url(#clip0_849_574)">
					<path d="M339.242 13.7603V8.2562H336.484V5.50413H330.968V2.75207H325.452V0H16.5484V2.75207H11.0323V5.50413H5.51613V8.2562H2.75806V13.7603H0V23.2397H2.75806V28.7438H5.51613V31.4959H11.0323V34.2479H16.5484V37H325.452V34.2479H330.968V31.4959H336.484V28.7438H339.242V23.2397H342V13.7603H339.242Z"
					      fill="#EEEECE"/>
					<path d="M335.533 17.2416V12.1096H332.962V9.54343H327.818V6.97728H322.675V4.41113H19.3247V6.97728H14.1812V9.54343H9.03771V12.1096H6.46627V17.2416H3.89453V19.7582H6.46627V24.8902H9.03771V27.4563H14.1812V30.0225H19.3247V32.5886H322.675V30.0225H327.818V27.4563H332.962V24.8902H335.533V19.7582H338.105V17.2416H335.533Z"
					      fill="#A8A78A"/>
					<path d="M171.486 4.41016V32.5883H19.326V30.023H14.1806V27.4572H9.03839V24.8889H6.46726V19.7575H3.89307V17.2412H6.46726V12.1098H9.03839V9.54429H14.1806V6.97569H19.326V4.41016H171.486Z"
					      fill="#CEC85B"/>
					<path d="M37.3318 0H34.5737V37H37.3318V0Z" fill="#EEEECE"/>
					<path d="M71.0935 0H68.3354V37H71.0935V0Z" fill="#EEEECE"/>
					<path d="M104.855 0H102.097V37H104.855V0Z" fill="#EEEECE"/>
					<path d="M138.617 0H135.859V37H138.617V0Z" fill="#EEEECE"/>
					<path d="M172.379 0H169.621V37H172.379V0Z" fill="#EEEECE"/>
					<path d="M206.141 0H203.383V37H206.141V0Z" fill="#EEEECE"/>
					<path d="M239.903 0H237.145V37H239.903V0Z" fill="#EEEECE"/>
					<path d="M273.664 0H270.906V37H273.664V0Z" fill="#EEEECE"/>
					<path d="M307.426 0H304.668V37H307.426V0Z" fill="#EEEECE"/>
				</g>
				<defs>
					<clipPath id="clip0_849_574">
						<rect width="342" height="37" fill="white"/>
					</clipPath>
				</defs>
			</svg>
	)
}
export default XpBar_SVG;